// src/components/OrderEntry/utils/insurance.js
// =============================================================================
// INSURANCE UTILITIES
// =============================================================================
// Extracted from OrderEntry.jsx BLOCK OE.7C
// Notes already drive "NOT DECLARE". We also infer from selected Terms text.
// =============================================================================

/**
 * Infer zero insurance requirement from notes and terms text
 *
 * Checks for phrases like:
 *  - "NOT DECLARE"
 *  - "DO NOT DECLARE"
 *  - "NO INSUR"
 *  - "0 INSUR"
 *  - "$0 INSUR"
 *
 * @param {object} params
 * @param {string[]} params.notesLines - Customer notes
 * @param {string} params.termsText - Terms description text
 * @returns {boolean} True if zero insurance should be applied
 */
export default function inferZeroInsurance({ notesLines, termsText }) {
  const notesJoined = Array.isArray(notesLines) ? notesLines.join(' ') : '';
  const n = String(notesJoined).toUpperCase();
  const t = String(termsText ?? '').toUpperCase();

  // Match known language + common variations
  const hit =
    n.includes('NOT DECLARE') ||
    t.includes('NOT DECLARE') ||
    t.includes('DO NOT DECLARE') ||
    t.includes('NO INSUR') ||
    t.includes('0 INSUR') ||
    t.includes('$0 INSUR');

  return Boolean(hit);
}
